import * as React from 'react';

export default class ImageIcon extends React.Component {
  render() {
    return React.createElement('svg', {
      className: this.props.className,
      viewBox: '0 0 82.9 68.9',
      dangerouslySetInnerHTML: {
        __html:
          '<path fill="#cccccc" d="M77.4,68.9H5.5c-3,0-5.5-2.5-5.5-5.5V5.5C0,2.5,2.5,0,5.5,0h71.9c3,0,5.5,2.5,5.5,5.5v57.9C82.9,66.4,80.5,68.9,77.4,68.9z M5.5,3C4.1,3,3,4.1,3,5.5v57.9c0,1.4,1.1,2.5,2.5,2.5h71.9c1.4,0,2.5-1.1,2.5-2.5V5.5c0-1.4-1.1-2.5-2.5-2.5H5.5z M67.2,54.5H15.8c-0.8,0-1.5-0.7-1.5-1.5v-5.2c0-0.3,0.1-0.6,0.3-0.9l10.3-14.8c0.4-0.6,1.3-0.8,2-0.4l8.7,5.1l17.8-19.1c0.3-0.3,0.7-0.5,1.2-0.5c0.5,0,0.9,0.3,1.1,0.6l12.9,18.6c0.2,0.2,0.3,0.5,0.3,0.9V53C68.7,53.9,68,54.5,67.2,54.5z M17.3,51.5h48.4V37.8L54.2,21.1L36.9,39.8c-0.5,0.5-1.3,0.6-1.9,0.3l-8.5-5l-9.2,13.3V51.5zM21.7,24.2c-3.1,0-5.7-2.5-5.7-5.7s2.5-5.7,5.7-5.7s5.7,2.5,5.7,5.7S24.8,24.2,21.7,24.2z M21.7,15.8c-1.5,0-2.7,1.2-2.7,2.7c0,1.5,1.2,2.7,2.7,2.7s2.7-1.2,2.7-2.7C24.3,17,23.1,15.8,21.7,15.8z"/>',
      },
    });
  }
}
